import { Controller } from '@hotwired/stimulus';

import { copyToClipboard } from '../models/helpers';

export default class extends Controller {
  static targets = ['link', 'successText'];

  linkTarget: HTMLInputElement;

  successTextTarget: HTMLElement;

  copy(event: Event) {
    event.preventDefault();
    copyToClipboard(this.linkTarget);
    this.successTextTarget.classList.remove('u-hidden');
  }
}
